export interface ParsedBlock {
  index: number
  content: string
  textContent: string
}

export const parseBlockList = (content: string): ParsedBlock[] => {
  const blockTextList = content.split(/\n\n+/)

  return blockTextList
    .map((text, index) => {
      const trimmedText = text.trim()

      if (!trimmedText) {
        return null
      }

      return {
        index,
        content: trimmedText,
        textContent: trimmedText,
      }
    })
    .filter((b): b is ParsedBlock => b !== null)
}
